import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 어플리케이션/시스템 로그의 장비종류 목록을 조회한다.
   * @author leesy918
   * @param  {[type]} param [description]
   * @return {[type]}       [description]
   */
  getLmsGridMenu(param) {
    return axios.post(`${baseUrl}/settings/lms-grid-menu/get-lms-grid-menu.do`, param);
  },
  /**
   * 선택한 장비종류의 리스트를 조회한다.
   * @author leesy918
   * @param  {[type]} param [description]
   * @return {[type]}       [description]
   */
  getSelectObjTypeMenu(param) {
    return axios.post(`${baseUrl}/settings/lms-grid-menu/get-select-obj-type-menu.do`, param);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/log/lms-grid-menu-setting.js